<template>
  <div>
    <b-modal id="modalEditTelephoneDirections" ref="modalEditTelephoneDirections" :title="$t('Telephone zones detail')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.dir_id > 0">
          <b-form-input type="text" disabled v-model="editItem.dir_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Zone')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.dir_id > 0">
          <b-form-input type="text" disabled v-model="editItem.zones"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="listOfTypeTelDirections" v-model="editItem.dir_coverage_type" :disabled="editItem.dir_id > 0 && editItem.zone_id > 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Called prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.called_prefix"/>
          <b-form-checkbox v-model="editItem.called_prefix_regexp">{{ $t('Regular Expression') }}</b-form-checkbox>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Calling prefix')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.calling_prefix"/>
          <b-form-checkbox v-model="editItem.calling_prefix_regexp">{{ $t('Regular Expression') }}</b-form-checkbox>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Incoming trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.incoming_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Outgoing trunk')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.outgoing_trunk"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('PBX ID')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.pbx_id"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Skip')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-checkbox v-model="editItem.skip"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditTelephoneDirections.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      listOfTypeTelDirections: [
        {text: this.$i18n.t('Local coverage'), value: 0},
        {text: this.$i18n.t('Innerzone coverage'), value: 1},
        {text: this.$i18n.t('Intercity coverage'), value: 2},
        {text: this.$i18n.t('International coverage'), value: 3}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.called_prefix || this.editItem.calling_prefix || this.editItem.incoming_trunk || this.editItem.outgoing_trunk || this.editItem.pbx_id) {
        this.editItem.type = this.editItem.dir_coverage_type
        let response = this.editItem.dir_id !== 0
          ? this.$store.dispatch('Tariffing/UPDATE_TEL_DIRECTIONS', this.editItem)
          : this.$store.dispatch('Tariffing/CREATE_TEL_DIRECTIONS', this.editItem)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TEL_DIRECTIONS_LIST')
            this.$refs.modalEditTelephoneDirections.hide()
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('At least one field mast be non-empty'), 'Error')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/telephone/telephoneDirections/editModal.vue